import type {ReactElement} from 'react';
import React, {useState} from 'react';
import {Icon} from '@Components/icon-v2';
import {FlatIconColor, FlatIconColorType, IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import styles from './error-box.module.scss';

interface ErrorBoxProps extends ErrorBoxInputs {
  icon?: string;
}

export interface ErrorBoxInputs {
  title: string;
  description: string;
  isPlain?: boolean;
  descriptionSize?: TextSize;
}

export function ErrorBox({title = '', description = '', icon = 'icon-exclamation-triangle', isPlain = false, descriptionSize = TextSize.XSMALL}: ErrorBoxProps): ReactElement<any> {
  const [isHidden, setIsHidden] = useState(false);
  const hideError = (): void => {
    setIsHidden(true);
  };

  const shouldHide = (): boolean => {
    return title === '' && description === '';
  };

  return (
    <div className={`${styles.container} ${isHidden || shouldHide() ? '_hidden' : ''} ${isPlain ? styles.plain : ''}`}>
      <div className={styles.closeIcon}>
        <Icon icon="icon-close" onClick={hideError} type={IconType.GHOST_UNCOLORED} shape={IconShape.SQUARE} size={IconSize.SIZE_ICON_16} />
      </div>
      <div className="spacing-m-r-1">
        <Icon
          icon={icon}
          type={IconType.FLAT}
          flatIconType={{type: FlatIconColorType.DEFAULT, color: FlatIconColor.DANGER}}
          shape={IconShape.CIRCLE}
          size={IconSize.SIZE_ICON_16}
          className={isPlain ? styles.plainIcon : ''}
        />
      </div>
      <div className="flex-v-row spacing-m-l-2 spacing-m-t-1">
        <Text val={title} size={TextSize.SMALL} bold={!isPlain} className={styles.title} />
        <Text val={description} size={descriptionSize} className={styles.description} />
      </div>
    </div>
  );
}
